module.exports = __webpack_public_path__ + "media/images/athletes/3563-d941e129875b8ec1d2e8009e7341da32.png";